<template>
  <!-- prettier-ignore -->
  <div class="Error">
    <h2>{{ translations.title[language] }}</h2>
    <ul>
      <li
        v-for="message in messages"
        :key="message.errorCode">
        {{ translations[message.errorCode][language] }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue'

// Props
defineProps({
  messages: {
    type: Array,
    default: () => [],
  },

  language: {
    type: String,
    default: 'de',
  },
})

// Data
const translations = computed(() => {
  return {
    title: {
      de: 'Etwas ging schief...',
    },
    PARTNERWIDGET_BUNDLE_NOT_FOUND: {
      de: 'Die Bundle wurde nicht gefunden. Bitte prüfen Sie die Bundlecode.',
    },
  }
})
</script>

<style scoped>
.Error {
  border: 1px solid var(--c-secondary-neutral-3);
  background-color: var(--c-primary-neutral-2);
  font-family: 'Open Sans', sans-serif;
  padding: 20px;

  ul {
    border: 1px solid var(--c-secondary-color-1);
    margin: 20px 0;
    padding: 30px 30px 10px;

    li {
      color: var(--c-secondary-color-1);
      margin: 0 0 20px;
      padding: 0;
      list-style-type: none;
    }
  }
}
</style>
